export default __webpack_public_path__ + "static/media/pandas.26ff1c05.svg";